import React, { useState } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Chip from 'components/Chip/Chip';
import Input from 'components/Input/Input';
import RichText from 'components/RichText/RichText';
import { Separator } from 'components/ui/separator';

type SegmentFieldsProps = {
  segment: string;
  setSegment: (value: string) => void;
  currentSegments: string[];
  getValues: (field: string) => any;
  setValue: (field: string, value: any, options?: any) => void;
  segmentOptions: string[];
};

const SegmentSection: React.FC<SegmentFieldsProps> = ({
  segment,
  setSegment,
  currentSegments,
  getValues,
  setValue,
  segmentOptions
}) => {
  const [segmentError, setSegmentError] = useState('');

  const handleAddSegment = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && segment.trim()) {
      e.preventDefault();
      const current = getValues('segments') || [];
      if (
        current.some(
          (s: string) => s.toLowerCase() === segment.trim().toLowerCase()
        )
      ) {
        setSegment('');
        return;
      }
      setValue('segments', [...current, segment.trim()], {
        shouldDirty: true,
        shouldValidate: true
      });
      setSegment('');
      setSegmentError('');
    }
  };

  const handleSegmentChange = (value: string) => {
    setSegment(value);
    if (
      currentSegments.some(
        (s) => s.toLowerCase() === value.trim().toLowerCase()
      )
    ) {
      setSegmentError("You can't add the same segment twice");
    } else {
      setSegmentError('');
    }
  };

  const handleSegmentBlur = () => {
    setSegmentError('');
  };

  const handleRemoveSegment = (indexToRemove: number) => {
    const currentSegments = getValues('segments');
    const updated = currentSegments.filter(
      (_: string, i: number) => i !== indexToRemove
    );
    setValue('segments', updated, {
      shouldDirty: true,
      shouldValidate: true
    });
  };

  return (
    <div className="pb-5 w-full">
      <Separator className="mb-8 mt-5 bg-base-border" />
      <RichText
        title="Segments"
        description="Create or add players segments to your bar"
        className="mb-7"
      />
      <Input
        value={segment}
        onChange={(e) => handleSegmentChange(e.target.value)}
        onKeyDown={handleAddSegment}
        onBlur={handleSegmentBlur}
        description={segmentError || "Press 'Enter' to add a new segment"}
        label="Segment Name"
        rightIconStyles="w-[15px] h-[15px] text-[15px]"
        rightIcon={<FontAwesomeIcon icon="fa-regular fa-magnifying-glass" />}
        placeholder="Search Segment"
        list="segment-options"
        state={segmentError ? 'error' : 'default'}
      />
      <datalist id="segment-options">
        {segmentOptions
          .filter((option) => !currentSegments.includes(option))
          .map((option) => (
            <option value={option} key={option} />
          ))}
      </datalist>
      {currentSegments.length > 0 && (
        <div className="flex gap-x-2 mt-3">
          {currentSegments.map((segment, index) => (
            <Chip
              onClick={() => handleRemoveSegment(index)}
              status="primary"
              key={index}
              className="group relative hover:cursor-pointer"
            >
              {segment}
              <FontAwesomeIcon
                icon="fa-regular fa-xmark"
                className="invisible group-hover:visible absolute text-[10px] -right-1.5 -top-1.5 rounded-full bg-base-popoverForeground"
              />
            </Chip>
          ))}
        </div>
      )}
    </div>
  );
};
export default SegmentSection;
